export default "__VITE_ASSET__0sFyaquU__"